/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { systemConfigurationGeneralResource } from '@jira/router-resources__system-configuration-settings/src/systemConfigurationGeneralResource.tsx';
import { systemConfigurationRedirectRoute } from '@jira/router-routes__admin-pages-system-configuration-routes/src/systemConfigurationRedirectRoute.tsx';
import SystemConfigurationGeneralRedirect from './common/ui/redirect/system-configuration-general-redirect/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const systemConfigurationRedirectRouteEntry: Route = createEntry(
	systemConfigurationRedirectRoute,

	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: SystemConfigurationGeneralRedirect,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			systemConfigurationGeneralResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
